/**
 * The chat motion vocabulary (EMR-2617): `tailwindcss-animate` class lists and
 * the one reduced-motion override for chat's Radix content.
 *
 * Rules (spec "Behavior"):
 * - Every entry that animates carries `motion-safe:`, so
 *   `prefers-reduced-motion: reduce` shows the change at once.
 * - Opacity and transform only; 150 ms, or 200 ms for the phone sheet panel.
 * - `reduceRadix` is the exception: chat renders design-system Radix content
 *   whose own `data-[state=open]:animate-in` selector beats a plain
 *   `motion-reduce:animate-none`, so it needs `!`.
 *
 * The strings stay literal so Tailwind's content scan finds them (the
 * `src` glob in frontend/tailwind.config.mjs).
 */
export const MOTION = {
  /** A new live message: fade from 0 and slide up 4 px. */
  enter:
    'motion-safe:animate-in motion-safe:fade-in-0 motion-safe:slide-in-from-bottom-1 motion-safe:duration-150',
  /** A sent row that this list showed as pending: fade from 60%, no slide. */
  settle:
    'motion-safe:animate-in motion-safe:fade-in-60 motion-safe:duration-150',
  /** A reaction chip that appeared or changed count: scale from 90%. */
  pop: 'motion-safe:animate-in motion-safe:zoom-in-90 motion-safe:duration-150',
  /** A suggestion list (`: shortcode: `, `@`) or the sheet scrim. */
  fade: 'motion-safe:animate-in motion-safe:fade-in-0 motion-safe:duration-150',
  /** A chat window or the open dock: fade and scale from 95%, bottom edge. */
  window:
    'origin-bottom motion-safe:animate-in motion-safe:fade-in-0 motion-safe:zoom-in-95 motion-safe:duration-150',
  /** The phone sheet panel: slide up from below. */
  sheet:
    'motion-safe:animate-in motion-safe:slide-in-from-bottom-full motion-safe:duration-200',
  /** Chat's Radix content: no motion of any kind under reduced motion. */
  reduceRadix: 'motion-reduce:!animate-none',
} as const;
